var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.967,
    height: 121.441,
    viewBox: "0 0 121.967 121.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11581",
    "data-name": "Group 11581",
    transform: "translate(-2.105 -2.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49435",
    "data-name": "Path 49435",
    d: "M78.5,44.845a11.089,11.089,0,0,0-11.04-10.5h-3.68V24.532a24.532,24.532,0,1,0-49.065,0v9.813H11.04A11.056,11.056,0,0,0,0,45.385V87.09A11.056,11.056,0,0,0,11.04,98.13H45.974a42.152,42.152,0,0,1-1.815-12.266A41.648,41.648,0,0,1,78.5,44.845Zm-53.971-10.5V24.532a14.719,14.719,0,0,1,29.439,0v9.813Z",
    transform: "translate(2.105 2.632)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11582",
    "data-name": "Group 11582",
    transform: "translate(-30.769 -14.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47394",
    "data-name": "Path 47394",
    d: "M1092.492,902.014a33.632,33.632,0,1,1,33.633-33.633A33.672,33.672,0,0,1,1092.492,902.014Z",
    transform: "translate(-971.284 -762.987)",
    fill: "#26b451"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47395",
    "data-name": "Path 47395",
    d: "M1243.873,1070.619a2.073,2.073,0,0,1-1.469-.609l-7.831-7.831a2.077,2.077,0,0,1,2.937-2.937l6.363,6.364,17.409-17.411a2.078,2.078,0,0,1,2.938,2.938l-18.878,18.878a2.069,2.069,0,0,1-1.467.609Z",
    transform: "translate(-1128.188 -953.705)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.dddcc0f1f0eea13216c475ea440a76f2.svg";
export { ForwardRef as ReactComponent };